import {
  urlcantiere,
  urlcommittenti,
  urlcontratti,
  urleventi,
  urllogin,
  urlprofilo,
  urlreferenti,
  urltask,
  urlutenti,
  urlmetodi,
  urlfiles,
  urlstati,
  urlrefresh,
} from "../lib/api.ts";
import { setCommittenti } from "./Reducers/CommittentiReducer.ts";
import { setContratti } from "./Reducers/ContrattoQuadroReducer.ts";
import { setEventi } from "./Reducers/EventoReducer.ts";
import { setLogin, setProfilo, setRefresh } from "./Reducers/LoginReducer.ts";
import { setReferenti } from "./Reducers/ReferentiReducer.ts";
import { setTask } from "./Reducers/TaskReducer.ts";
import { setUtenti } from "./Reducers/UtentiReducer.ts";
import { AppDispatch } from "./Store/index.ts";
import { useAlert } from "../Components/Alert.tsx";
import { setMetodi } from "./Reducers/MetodoPagamentoReducer.ts";
import { setCantieri } from "./Reducers/CantiereReducer.ts";
import { setStati } from "./Reducers/StatoReducer.ts";

// Mappa di URL associati alle rispettive funzioni del reducer
const urlToReducerMap: Record<string, Function> = {
  [urlutenti]: setUtenti,
  [urlcantiere]: setCantieri,
  [urlcommittenti]: setCommittenti,
  [urlcontratti]: setContratti,
  [urleventi]: setEventi,
  [urltask]: setTask,
  [urlreferenti]: setReferenti,
  [urlmetodi]: setMetodi,
  [urlstati]: setStati,
};
export const loginUser = (payload: { email: string; password: string; rememberMe: boolean }) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(urllogin, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        const token = result.token;
        const refreshToken = result.refreshToken;
        const payloadLogin = {
          token: token,
          refreshToken: refreshToken,
          email: payload.email,
          stayLoggedIn: payload.rememberMe,
        };
        dispatch(setLogin(payloadLogin));
        dispatch(getProfilo(token));
        dispatch(reduxFiller(token));
        return { success: true };
      } else {
        const errorResult = await response.json();
        return {
          success: false,
          errorMessage: errorResult.message,
          errorDescription: errorResult.description,
        };
      }
    } catch (error: any) {
      return {
        success: false,
        errorMessage: error.message,
        errorDescription: error.description,
      };
    }
  };
};
export const handleRefreshToken = async (payload: { email: string; refreshToken: string }) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(urlrefresh, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Token refresh failed");
      }

      const data = await response.json();
      const payloadRefresh = { token: data.token, refreshToken: data.refreshToken };
      console.log(payloadRefresh);
      dispatch(setRefresh(payloadRefresh));
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  };
};
export const getProfilo = (token: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(urlprofilo, {
        method: "GET",
        headers: {
          Authorization: `Bearer ` + token,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const result = await response.json();

        dispatch(setProfilo(result));
      } else {
        console.error("Failed to fetch user info");
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
};
export const reduxFiller = (token: string) => {
  return (dispatch: AppDispatch) => {
    Object.entries(urlToReducerMap).forEach(([url, reducerFunction]) => {
      dispatch(allGet(url, token, reducerFunction));
    });
  };
};

// Funzione generica `allGet` che accetta un `reducerFunction` opzionale
export const allGet = (url: string, token: string, reducerFunction?: Function, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ` + token },
      });

      if (response.ok) {
        const result = await response.json();

        // Se `reducerFunction` è passato, effettua il dispatch dei dati al reducer
        if (reducerFunction) {
          dispatch(reducerFunction(result));
        }

        return result;
      } else {
        const errorData = await response.json();
        console.error("GET fallita:", errorData.message);
        showAlert &&
          showAlert("danger", "Errore", `Errore durante la richiesta GET: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore GET:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante la richiesta GET.", "bottom-end", 3000);
      return null;
    }
  };
};

export const allPost = (url: string, token: string, body: any, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ` + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        const result = await response.json();

        dispatch(reduxFiller(token));
        return result.id;
      } else {
        const errorData = await response.json();
        console.error("POST fallita:", errorData.message);
        showAlert && showAlert("danger", "Errore", `Errore POST: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore POST:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante la richiesta POST.", "bottom-end", 3000);
      return null;
    }
  };
};

export const allPut = (url: string, token: string, body: any, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ` + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        const result = await response.json();

        dispatch(reduxFiller(token));
        return result;
      } else {
        const errorData = await response.json();
        console.error("PUT fallita:", errorData.message);
        showAlert && showAlert("danger", "Errore", `Errore PUT: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore PUT:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante la richiesta PUT.", "bottom-end", 3000);
      return null;
    }
  };
};

export const allPatch = (url: string, token: string, body: any, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ` + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok || response.status === 204) {
        // Controlla anche se lo stato è 204

        dispatch(reduxFiller(token)); // Riempie i dati nel Redux solo se necessario
        return true; // Indica successo
      } else {
        const errorData = await response.json();
        console.error("PATCH fallita:", errorData.message);
        showAlert && showAlert("danger", "Errore", `Errore PATCH: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore PATCH:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante la richiesta PATCH.", "bottom-end", 3000);
      return null;
    }
  };
};

export const allDelete = (url: string, token: string, id: string, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(`${url}/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        dispatch(reduxFiller(token));
        return true;
      } else {
        const errorData = await response.json();
        console.error("DELETE fallita:", errorData.message);
        showAlert && showAlert("danger", "Errore", `Errore DELETE: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore DELETE:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante la richiesta DELETE.", "bottom-end", 3000);
      return null;
    }
  };
};

export const uploadFile = (
  token: string,
  file: File,
  uploadedBy: string,
  folderKey: string,
  folderType: string,
  filePrincipale: boolean,
  showAlert?: Function,
  customFolder?: string // Aggiunto customFolder come parametro opzionale
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      // Mappatura di folderType in queryParams specifici
      const queryParams: { [key: string]: string } = {
        uploadedBy,
        filePrincipale: String(filePrincipale),
      };

      // Trasforma folderKey nel parametro appropriato basato su folderType
      if (folderType === "committenti") {
        queryParams["committenteId"] = folderKey;
      } else if (folderType === "contratti") {
        queryParams["contrattoQuadroId"] = folderKey;
      } else if (folderType === "cantieri") {
        queryParams["cantiereId"] = folderKey;
      } else if (folderType === "eventi") {
        queryParams["eventoId"] = folderKey;
      }

      // Aggiungi customFolder se è stato fornito
      if (customFolder) {
        queryParams["customFolder"] = customFolder;
      }

      // Costruzione della query string
      const queryString = new URLSearchParams(queryParams).toString();

      // Determina endpoint in base alla dimensione del file (5MB soglia)
      const endpoint =
        file.size < 5_000_000 ? `${urlfiles}/upload?${queryString}` : `${urlfiles}/upload/multipart?${queryString}`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.text();
        const idMatch = result.match(/ID\s*=\s*([a-z0-9-]+)/i);
        const fileKey = idMatch && idMatch[1] ? idMatch[1] : null;

        const resulttext = {
          fileKey,
          rawMessage: result,
        };
        showAlert && showAlert("success", "Successo", "File caricato con successo.", "bottom-end", 3000);
        return resulttext;
      } else {
        const errorData = await response.json();
        console.error("Upload fallito:", errorData.message);
        showAlert && showAlert("danger", "Errore", `Errore durante l'upload: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore durante l'upload del file:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante l'upload del file.", "bottom-end", 3000);
      return null;
    }
  };
};

export const getFiles = (token: string, folderKey: string, folderType: string, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const url = `${urlfiles}/folder?folderKey=${folderType}/${folderKey}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("GET fallito:", errorData.message);
        if (response.status === 404 && errorData.message.includes("Nessun file trovato")) {
          return [];
        } else {
          showAlert &&
            showAlert(
              "danger",
              "Errore",
              `Errore durante il recupero dei file: ${errorData.message}`,
              "bottom-end",
              3000
            );
          return null;
        }
      }

      const fileEntries = await response.json();

      // Calcoliamo la lunghezza "attesa" per i file nella cartella corrente
      const keyParts = folderKey.split("/").filter((p) => p.trim() !== "");
      const expectedLength = 2 + keyParts.length;
      // parts[0]=folderType, parts[1..X]=folderKey diviso in sottocartelle, ultimo livello = fileName

      const subfolders = new Set<string>();
      const mainFiles: any[] = [];

      for (const fileEntry of fileEntries) {
        const parts = fileEntry.fileKey.split("/");
        if (parts.length === expectedLength) {
          // File nella cartella attuale
          mainFiles.push(fileEntry);
        } else if (parts.length > expectedLength) {
          // C'è una sottocartella
          const subfolderName = parts[expectedLength - 1];
          subfolders.add(subfolderName);
        }
      }

      const mainFileKeys = mainFiles.map((fileEntry: any) => {
        const parts = fileEntry.fileKey.split("/");
        const fileName = parts[parts.length - 1];
        return {
          fileName,
          id: fileEntry.id,
          uploadedBy: fileEntry.uploadedBy,
          uploadedAt: fileEntry.uploadedAt,
        };
      });

      const presignedUrls = await Promise.all(
        mainFileKeys.map(async (fileObj) => {
          const { fileName, id, uploadedBy, uploadedAt } = fileObj;
          const presignedUrl = `${urlfiles}/presigned-url?filePath=${folderType}/${folderKey}/${fileName}`;
          const presignedResponse = await fetch(presignedUrl, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (presignedResponse.ok) {
            const result = await presignedResponse.text();
            return {
              fileKey: fileName,
              url: result,
              isFolder: false,
              id,
              uploadedBy,
              uploadedAt,
            };
          } else {
            console.error(`Errore nel recupero del presigned URL per ${fileName}`);
            return null;
          }
        })
      );

      const validPresignedUrls = presignedUrls.filter((url) => url !== null) as {
        fileKey: string;
        url: string;
        isFolder: boolean;
        id: string;
        uploadedBy: string;
        uploadedAt: string;
      }[];

      const folderEntries = Array.from(subfolders).map((folderName) => ({
        fileKey: folderName,
        isFolder: true,
      }));

      const finalList = [...folderEntries, ...validPresignedUrls];

      showAlert && showAlert("success", "Successo", "File recuperati con successo.", "bottom-end", 3000);

      return finalList;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante il recupero dei file.", "bottom-end", 3000);
      return null;
    }
  };
};

export const moveFiles = (token: string, fileId: string, newFolder: string, showAlert?: Function) => {
  return async (dispatch: AppDispatch) => {
    try {
      const sanitizedUrlFolder = newFolder.endsWith("/") ? newFolder.slice(0, -1) : newFolder;
      const url = `${urlfiles}/${fileId}/move?fileId=${fileId}&newFolder=${encodeURIComponent(sanitizedUrlFolder)}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const result = await response.text();

        showAlert && showAlert("success", "Successo", "File spostato con successo.", "bottom-end", 3000);
        return true;
      } else {
        const errorData = await response.json();
        console.error("MOVE fallito:", errorData.message);
        showAlert &&
          showAlert(
            "danger",
            "Errore",
            `Errore durante lo spostamento del file: ${errorData.message}`,
            "bottom-end",
            3000
          );
        return null;
      }
    } catch (error) {
      console.error("Errore durante lo spostamento del file:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante lo spostamento del file.", "bottom-end", 3000);
      return null;
    }
  };
};

export const downloadFiles = (
  folderType: string,
  folderKey: string,
  fileId: string,
  fileKey: string,
  token: string,
  showAlert?: Function
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetch(`${urlfiles}/download?fileId=${encodeURIComponent(fileId)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ` + token },
      });

      if (response.ok) {
        const blob = await response.blob(); // Leggiamo la risposta come blob binario

        // Creiamo un link temporaneo per il download
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileKey); // nome del file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl); // rilascio dell'URL temporaneo

        showAlert && showAlert("success", "Successo", "Download avviato con successo.", "bottom-end", 3000);
        return true;
      } else {
        const errorData = await response.json();
        console.error("GET fallita:", errorData.message);
        showAlert &&
          showAlert("danger", "Errore", `Errore durante la richiesta GET: ${errorData.message}`, "bottom-end", 3000);
        return null;
      }
    } catch (error) {
      console.error("Errore GET:", error);
      showAlert && showAlert("danger", "Errore", "Errore durante la richiesta GET.", "bottom-end", 3000);
      return null;
    }
  };
};
